import { Experiment } from '@naturalcycles/shared'
import { QuizPage } from '@src/app/cnst/quiz/quiz-pages.cnst'
import { addPageToFlowAfterCurrent, QuizModifier } from '@src/app/util/quiz.util'
import { DefaultQuizSection, QuizSections } from '@src/typings/quiz.enum'
import { AppQuizEngineConfig, AppQuizFlow, QuizSignatureObject } from '@src/typings/quiz.model'

class MedicalAdvisoryBoardQuiz implements QuizModifier<AppQuizEngineConfig> {
  public _shouldEnhance(obj: QuizSignatureObject): boolean {
    return obj.experiment[Experiment.APP_QUIZ_MEDICAL_ADVISORY_BOARD] === 'test'
  }

  public enhanceEngineConfig(
    obj: QuizSignatureObject,
    config: AppQuizEngineConfig,
  ): AppQuizEngineConfig {
    if (!this._shouldEnhance(obj)) return config

    config.guardData[QuizPage.medicalAdvisoryBoardInfo] = s => !!s?.fertilityGoal
    return config
  }

  public enhanceSections(obj: QuizSignatureObject, sections: QuizSections): QuizSections {
    if (!this._shouldEnhance(obj)) return sections

    return sections
  }

  public enhanceInitialFlow(obj: QuizSignatureObject, flow: AppQuizFlow): AppQuizFlow {
    if (!this._shouldEnhance(obj)) return flow

    return addPageToFlowAfterCurrent(
      flow,
      DefaultQuizSection.intro,
      QuizPage.fertilityGoal,
      QuizPage.medicalAdvisoryBoardInfo,
    )
  }

  public enhanceEntry(obj: QuizSignatureObject, entry: QuizPage | null): QuizPage | null {
    if (!this._shouldEnhance(obj)) return entry
    return entry
  }

  public enhanceExit(obj: QuizSignatureObject, exit: QuizPage | null): QuizPage | null {
    if (!this._shouldEnhance(obj)) return exit
    return exit
  }
}

export const expMedicalAdvisoryBoardQuiz = new MedicalAdvisoryBoardQuiz()
